const iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

export function isIOS() {
  if (!!navigator.platform) {
    return iDevices.indexOf(navigator.platform) !== -1;
  }
  return false;
}
